import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  if (data.status === 'SUCCESS') {
    return data?.data
  } else {
    throw data.error ?? 'An unexpected error has occured while fetching supersetDasboard'
  }
}

const getAllSupersetDashboard = (merchantId: string, tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getSupersetDashboardList,
    method: 'POST',
    body: { merchantId },
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data?.data)
  })
}

export { getAllSupersetDashboard }
